<template>
  <SalesReport type="services" />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import SalesReport from '@/modules/reports/components/SalesReport.vue';

export default defineComponent({
  name: 'Services',
  components: { SalesReport },
});
</script>
